import axios from 'axios';

export default {
    REST: (url, data, config = null) => axios.post(url, data, config)
};
